/**
 * Initialize AJAX add-to-cart functionality for product forms
 * Handles forms after AJAX filter updates and ScrollBee infinite scroll
 */

(function() {
  'use strict';

  /**
   * Initialize AjaxProduct for add-to-cart forms
   * @param {NodeList|Array} forms - Forms to initialize
   * @returns {number} - Number of forms initialized
   */
  function initializeAddToCartForms(forms) {
    if (!forms || forms.length === 0) return 0;
    
    const cartType = window.theme?.settings?.cartType;
    if (cartType !== 'drawer') return 0;

    let initialized = 0;
    
    forms.forEach((form) => {
      // Skip if already initialized
      if (form._ajaxProductInitialized || form.hasAttribute('data-ajax-initialized')) return;
      
      // Initialize using theme's AjaxProduct
      if (window.theme?.AjaxProduct) {
        try {
          new window.theme.AjaxProduct(form);
          form._ajaxProductInitialized = true;
          form.setAttribute('data-ajax-initialized', 'true');
          initialized++;
        } catch (e) {
          console.error('Error initializing AjaxProduct:', e);
        }
      }
    });
    
    return initialized;
  }

  /**
   * Find and initialize all uninitialized add-to-cart forms
   */
  function initAllForms() {
    const forms = document.querySelectorAll('.product-single__form-atc:not([data-ajax-initialized])');
    return initializeAddToCartForms(forms);
  }

  /**
   * Setup MutationObserver for ScrollBee infinite scroll
   * Watches for new products added to the scroll-bee-product-container
   */
  function setupScrollBeeObserver() {
    const container = document.querySelector('.scroll-bee-product-container');
    if (!container) {
      // Retry if container doesn't exist yet
      setTimeout(setupScrollBeeObserver, 500);
      return;
    }

    let debounceTimer;
    
    function handleNewProducts() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        const initialized = initAllForms();
        if (initialized > 0) {
          console.log('ScrollBee: Initialized', initialized, 'new add-to-cart forms');
        }
      }, 150);
    }
    
    const observer = new MutationObserver(function(mutations) {
      let hasNewProducts = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if the node itself is a form
              if (node.classList && node.classList.contains('product-single__form-atc')) {
                hasNewProducts = true;
                return;
              }
              // Check if node contains forms
              if (node.querySelectorAll) {
                const forms = node.querySelectorAll('.product-single__form-atc');
                if (forms.length > 0) {
                  hasNewProducts = true;
                }
              }
            }
          });
        }
      });

      if (hasNewProducts) {
        handleNewProducts();
      }
    });

    // Watch the ScrollBee container
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    });

    // Also watch for products added anywhere in collection grid areas
    const gridObserver = new MutationObserver(function(mutations) {
      let hasNewProducts = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              // Check if node is a form or contains forms
              if (node.matches && node.matches('.product-single__form-atc')) {
                hasNewProducts = true;
              } else if (node.querySelectorAll) {
                const forms = node.querySelectorAll('.product-single__form-atc:not([data-ajax-initialized])');
                if (forms.length > 0) {
                  hasNewProducts = true;
                }
              }
            }
          });
        }
      });

      if (hasNewProducts) {
        handleNewProducts();
      }
    });

    // Watch collection grid containers
    const gridContainers = document.querySelectorAll('.collection-grid__wrapper, .grid--uniform, [data-section-type="collection-grid"]');
    gridContainers.forEach(function(gridContainer) {
      gridObserver.observe(gridContainer, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
      });
    });

    // Listen for any ScrollBee-specific events
    document.addEventListener('scrollbee:loaded', function() {
      setTimeout(initAllForms, 200);
    });
    
    // Fallback: periodically check for new forms (in case MutationObserver misses something)
    setInterval(function() {
      const uninitialized = document.querySelectorAll('.product-single__form-atc:not([data-ajax-initialized])');
      if (uninitialized.length > 0) {
        const initialized = initializeAddToCartForms(uninitialized);
        if (initialized > 0) {
          console.log('ScrollBee fallback: Initialized', initialized, 'forms');
        }
      }
    }, 2000);
  }

  /**
   * Initialize on page load
   */
  function init() {
    // Initialize existing forms
    initAllForms();

    // Listen for collection AJAX filter reloads
    document.addEventListener('collection:reloaded', function() {
      setTimeout(initAllForms, 100);
    });

    // Setup ScrollBee observer for infinite scroll
    setupScrollBeeObserver();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* The Ever Good, Oct 17 2026: Nurture page only. Hides the app hint line "To add to cart, go to the product page and select a purchase option" next to the buy buttons. */
(function() {
  if (location.pathname.indexOf('/products/nurture') !== 0) return;
  var HINT = 'to add to cart, go to the product page and select a purchase option';
  function hideHint() {
    document.querySelectorAll('.product-single__meta *, .shopify_subscriptions_app_block *').forEach(function(el) {
      if (el.children.length === 0 && el.textContent.trim().toLowerCase() === HINT) { el.style.display = 'none'; }
    });
  }
  document.addEventListener('DOMContentLoaded', hideHint);
  window.addEventListener('load', hideHint);
  setInterval(hideHint, 1500);
})();
